<template>
    <!-- 地方特色 -->
    <div class="local_warp">
         <BasePage
            topImg="https://www.ynggwhy.cn/file/group1/M00/00/27/rNYBQF8w4rqEI3NJAAAAADDK5Mk596.png"
            tabNum="2"
            ref="basePage"
        >
            <template scope="{item}">
                <div class="list_item" :key="item.id" @click="toDetail(item)">
                    <div class="item_img_box">
                        <el-image class="item_img" :src="item.imageUrl">
                            <div slot="placeholder" class="image_slot">
                                <i class="el-icon-loading"></i>
                            </div>
                        </el-image>
                    
                        <div class="img_time_box">
                            <i class="el-icon-video-play" style="font-size:60px"></i>
                        </div>
                    </div>
                    <div class="item_info">
                        <div class="item_info_title ellipsis">{{item.title}}</div>
                        <div class="bot">
                            <span style="margin-right:auto;color: #2f7ef7;">播放 31761</span>
                            <svg-icon icon-class="comment" class-name="card-panel-icon" />
                            <span style="margin-right:7px">{{1}}</span>
                            <svg-icon icon-class="thumb" class-name="card-panel-icon" />
                            <span>{{1}}</span>
                        </div>
                        <div class="item_footer">
                            <img class="item_footer_icon" src="https://www.ynggwhy.cn/file/hbY3dGDs5jDBxn6RTX/2020-06-01/source/9b388f9766b64b4cbf7dabe8c27852ac.png" >
                            <span style="margin-right:auto">云南省文化馆</span>
                            <span>11-16</span>
                        </div>
                    </div>
                </div>
            </template>
        </BasePage>
    </div>
</template>

<script>
import BasePage from '@c/BasePage'


export default {
    name: 'localFeature',
    components: {
        BasePage
    },
    data() {
        return {

        }
    },
    beforeRouteUpdate(to, from, next) {
        this.$refs.basePage.loadImage(to.query.id)
        next()
    },
    methods: {
        toDetail(item) {
            this.$router.push(`/localFeature/detail/${1}`)
        }
    },
    mounted() {
        this.$refs.basePage.load('resource/offlinesource/list')
    }
}
</script>

<style scoped lang="scss">
@import "@/styles/com_item.scss";

.local_warp {
    background: #f8f8f8;
    .item_img {
        width: 100%;
        height: 217px;
        object-fit: cover;
    }
    .image_slot {
        text-align: center;
        padding-top: 50px;
        font-size: 30px;
    }
}
</style>